import { getStatefulApiHeaders } from '../csrf';

const MANIFEST_PREFIX = '/manifest-engine';

export function getManifestHeaders(
  accept = 'application/json',
  contentType?: string
): Record<string, string> {
  return getStatefulApiHeaders({
    Accept: accept,
    ...(contentType ? { 'Content-Type': contentType } : {})
  });
}

export function getManifestFetchInit(
  method: string,
  accept: string,
  body?: string
): RequestInit {
  return {
    method,
    credentials: 'include',
    headers: getManifestHeaders(
      accept,
      body ? 'application/json' : undefined
    ),
    ...(body ? { body } : {})
  };
}

export function manifestApiPath(suffix: string): string {
  const normalized = suffix.startsWith('/') ? suffix : `/${suffix}`;
  return `${MANIFEST_PREFIX}${normalized}`;
}
